import t from "../../../i18n/i18n";

function Benefits() {
  return (
    <div className="loyal-benefits gutter-40">
      <div className="benefits-header">
        <h3>
          <span className="icon">
            <img src="images/price-md-ico.png" alt="" />
          </span>{" "}
          {t("LoyalMember.Benefits.Title")}
        </h3>
      </div>
      <ul>
        <li>
          <div className="benefits-box">
            <div className="icon-benefits">
              <img src="images/benefits-ico1.png" alt="" />
            </div>
            <div className="benefits-info">
              <h4>{t("LoyalMember.Benefits.Payment")}</h4>
              <p>{t("LoyalMember.Benefits.PaymentDescription")}</p>
            </div>
          </div>
        </li>
        <li>
          <div className="benefits-box">
            <div className="icon-benefits">
              <img src="images/benefits-ico2.png" alt="" />
            </div>
            <div className="benefits-info">
              <h4>{t("LoyalMember.Benefits.Prize")}</h4>
              <p>{t("LoyalMember.Benefits.PrizeDescription")}</p>
            </div>
          </div>
        </li>
        <li>
          <div className="benefits-box">
            <div className="icon-benefits">
              <img src="images/benefits-ico3.png" alt="" />
            </div>
            <div className="benefits-info">
              <h4>{t("LoyalMember.Benefits.Service")}</h4>
              <p>{t("LoyalMember.Benefits.ServiceDescription")}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default Benefits;
